import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import { Badge, IconButton, Tooltip } from "@mzc-pdc/ui";
import { ImageMyjobsOff, ImageMyjobsOn } from "@mzc-cloudplex/icons";
import loadingLottie from "@assets/lottie/my-jobs-loading.json";
import { SIDEBAR_BUTTON_ID } from "@constants";
import useMyJobs from "@hooks/useMyJobs";

/**
 * 헤더의 「내 작업」 진입 버튼. 잡 패널을 닫아도 남는 유일한 자리라, 여기만 「어딘가에서 전송 중」을
 * 말해야 한다. Lottie 는 서버에서 도는 잡(트랜스코드 등)과 브라우저가 직접 전송하는 업로드를
 * 구분하지 않으므로, 「지금 나가면 안 되는 상태」는 Badge 점이 맡는다.
 *
 * 점만으로 의미를 전달하지 않는다 — 같은 내용을 라벨이 툴팁·aria-label 로 글로 말한다.
 * 배치(Grid 등)는 쓰는 쪽이 정한다.
 */
const MyJobsButton = () => {
    const { t } = useTranslation();
    const { openMyJobs, isJobExisting, isJobProcessing, isBrowserUploading } = useMyJobs({});

    const label = isBrowserUploading
        ? t(
              `common::msg::${"Uploading. Do not close or refresh this page."}`,
              `Uploading. Do not close or refresh this page.`,
          )
        : t(`common::label::My Jobs`, `My Jobs`);

    return (
        <Tooltip title={label}>
            <IconButton
                size={"large"}
                circled
                aria-label={label}
                sx={{ p: 1, "& div svg": { marginBottom: "8px" } }}
                id={SIDEBAR_BUTTON_ID}
                onClick={(e) => {
                    e.stopPropagation();
                    openMyJobs();
                }}
            >
                <Badge
                    color={"warning"}
                    variant={"dot"}
                    invisible={!isBrowserUploading}
                    overlap={"circular"}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{ ".MuiBadge-dot": { minWidth: 8, height: 8, borderRadius: "50%" } }}
                >
                    {isJobExisting && isJobProcessing && (
                        <Lottie
                            animationData={loadingLottie}
                            style={{
                                height: "24px",
                                minWidth: "24px",
                                margin: "auto",
                            }}
                        />
                    )}
                    {isJobExisting && !isJobProcessing && <ImageMyjobsOn width={24} height={24} />}
                    {!isJobExisting && <ImageMyjobsOff width={24} height={24} />}
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default MyJobsButton;
